import React from "react";
import { GridItem, GridContainer } from "./AcquirerForm.styles";
import TextField from "../../textField/TextField";
import CriptoWallets from "../../wallets/CriptoWallets";

const BankInfo = ({
  formValues,
  handleChange,
  handleBlur,
  errors,
  touched,
}) => {
  const { bank: { Iban, routingNumber, accountNumber, address } } = formValues;

  return (
    <GridContainer spacing={1.5}>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="bank.Iban"
          name="bank.Iban"
          fullWidth
          label="Bank Name"
          value={Iban}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.bank?.Iban}
          touched={touched.bank?.Iban}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="bank.address"
          name="bank.address"
          fullWidth
          label="Bank Address"
          value={address}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.bank?.address}
          touched={touched.bank?.address}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="bank.accountNumber"
          name="bank.accountNumber"
          fullWidth
          label="Account Number"
          value={accountNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.bank?.accountNumber}
          touched={touched.bank?.accountNumber}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="bank.routingNumber"
          name="bank.routingNumber"
          fullWidth
          label="Routing Number"
          value={routingNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.bank?.routingNumber}
          touched={touched.bank?.routingNumber}
        />
      </GridItem>
      <GridItem xs={12} padding="15px 15px 15px 0">
        <CriptoWallets 
          formValues={formValues}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
        />
      </GridItem>
    </GridContainer>
  );
};

export default BankInfo;
